import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';

import {
  categoryListReducer,
  categoryCreateReducer,
  categoryDetailsReducer,
  categoryDeleteReducer,
} from './reducers/categoryReducer';

import {
  userListReducer,
  userDetailsReducer,
  userRegisterReducer,
  userDeleteReducer,
} from './reducers/userReducers';
import {
  productCreateReducer,
  productListReducer,
} from './reducers/productReducer';
import { orderCreateReducer, orderListReducer } from './reducers/orderReducer';
import { userLoginReducer } from './reducers/userReducers';
const reducer = combineReducers({
  catList: categoryListReducer,
  cateCreate: categoryCreateReducer,
  catDetails: categoryDetailsReducer,
  catDelete: categoryDeleteReducer,
  userList: userListReducer,
  user: userDetailsReducer,
  userDelete: userDeleteReducer,
  productCreate: productCreateReducer,
  productList: productListReducer,
  orderNow: orderCreateReducer,
  orderList: orderListReducer,
  register: userRegisterReducer,

  userLogin: userLoginReducer,
});

// const userInfoFromStorage = localStorage.getItem('userInfo')
//   ? JSON.parse(localStorage.getItem('userInfo'))
//   : null;

const initialState = {
  // cart: {
  //   cartItems: cartItemsFromStorage,
  //   shippingAddress: shippingAddressFromStorage,
  // },
  // userLogin: { userInfo: userInfoFromStorage },
};

const middleware = [thunk];

// const store = createStore(
//   reducer,
//   initialState,
//   composeWithDevTools(applyMiddleware(...middleware))
// )

const store = createStore(
  reducer,
  initialState,
  compose(
    applyMiddleware(...middleware)
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
);

export default store;
